import { createSelector } from '@ngrx/store';
 
export const selectHttpRequestCount = (state: {httpRequestCount: number }) => state.httpRequestCount;
 
export const httpInProgress = createSelector(
  selectHttpRequestCount,
  (httpRequestCount: number) => httpRequestCount > 0,
);